import './style.modules.scss'

import React, { useState } from 'react'

export type CaptionProps = {
  caption: string
  title: string
  testId?: string
}

export const Caption: React.FC<CaptionProps> = ({ caption, title, testId }) => {
  const [isOpen, setIsOpen] = useState(false)

  if (!isOpen) {
    return (
      <div className="Caption u-adel-reset" data-testid={testId}>
        <button
          type="button"
          className="Caption-openModal Link"
          onClick={() => setIsOpen(true)}
          data-testid={testId ? `${testId}-open` : undefined}
        >
          {title}
        </button>
      </div>
    )
  }

  return (
    <div className="Caption u-adel-reset" data-testid={testId}>
      <button
        type="button"
        className="Caption-openModal"
        onClick={() => setIsOpen(false)}
        data-testid={testId ? `${testId}-open` : undefined}
      >
        {title}
      </button>
      <dialog
        className="Modal Modal--md Modal--sm"
        aria-labelledby="modalTitle"
        aria-describedby="modalDesc"
        data-testid={testId ? `${testId}-modal` : undefined}
      >
        <section className="Modal-window">
          <header className="Modal-header">
            <h3
              className="Modal-title"
              id="modalTitle"
              data-testid={testId ? `${testId}-title` : undefined}
            >
              {title}
            </h3>
            <button
              onClick={() => setIsOpen(false)}
              className="Modal-icon"
              data-testid={testId ? `${testId}-close` : undefined}
            >
              <span
                className="adel-material-symbols-24"
                title="Close this dialog"
                aria-label="Close this dialog"
              >
                close
              </span>
            </button>
          </header>
          <div className="Modal-content Content" id="modalDesc">
            <p data-testid={testId ? `${testId}-caption` : undefined}>
              {caption}
            </p>
          </div>
        </section>
      </dialog>
    </div>
  )
}
